import { api } from '../store/middleware/api'

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    driverSignup: build.mutation({
      query: (body) => ({
        url:`/auth/signup/driver`,
        method:"POST",
        body
      }),
    }),    
  }),
  overrideExisting: false,
})

export const { useDriverSignupMutation } = extendedApi